import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { IFullFormPageStoreShape } from 'store/modules/full-employee-form/iFullFormPageStore';
import { DynamicFormStyled, EmployeeFormWrapperStyled } from './styles';
import { EMPLOYEE_PROFILE_FORM_TEST_ID, EMPLOYEE_PROFILE_TAB_TEST_ID } from '../constants';

interface Props {
  readonly pageStore: IFullFormPageStoreShape;
}

const EmployeeProfileTab: React.FC<Props> = observer(({ pageStore }) => {
  const { employeeProfileTab, subscriberExists, isInitialDataLoading } = pageStore;
  const { dynamicJSONFormDelegate, fetchForm } = employeeProfileTab;
  const formExists = dynamicJSONFormDelegate.formController;

  useEffect(() => {
    if (!isInitialDataLoading && !formExists) {
      void fetchForm();
    }
  }, [isInitialDataLoading, formExists]);

  return (
    <EmployeeFormWrapperStyled data-test-id={EMPLOYEE_PROFILE_TAB_TEST_ID}>
      <DynamicFormStyled
        formDelegate={dynamicJSONFormDelegate}
        completeButtonText={subscriberExists ? 'Update' : 'Save'}
        data-test-id={EMPLOYEE_PROFILE_FORM_TEST_ID}
        noBorderOnError
      />
    </EmployeeFormWrapperStyled>
  );
});

export { EmployeeProfileTab };
